/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table } from "antd"
import TableStyle from "./Table.style"

interface TableProps {
  data: any;
  columns: any;
  pagination?: boolean;
  isLoading?: boolean;
  pageSize?: number;
  total?: number;
  handlePageChange?: any;
  currentPage?: number;
  onRowClick?: (record: any) => void;
  rowClassName?: string;
  scroll?: { x?: number | string | true; y?: number | string };
  className?: string; // Added className prop
  tableClassName?: string; // Added tableClassName prop for the inner Table component
}

const LocalTable = (props: TableProps) => {
  const {
    data,
    scroll,
    columns,
    pagination = true,
    isLoading = false,
    pageSize = 12,
    total,
    handlePageChange,
    currentPage = 1,
    onRowClick,
    rowClassName = '',
    className = '', 
    tableClassName = ''
  } = props

  return (
    <TableStyle>
      <div className={`contact-table ${className}`}>
        <div className={`contact-table__block ${tableClassName}`}>
          <Table
            loading={isLoading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            scroll={scroll}
            pagination={
              pagination
                ? {
                    pageSize,
                    current: currentPage,
                    total,
                    showTotal: (total, range) => `${range[1]}/ ${total}`,
                    showSizeChanger: true,
                  }
                : false
            }
            onRow={(record) => ({
              onClick: () => (onRowClick ? onRowClick?.(record) : null),
              className: rowClassName,
            })}
          />
        </div>
      </div>
    </TableStyle>
  );
}

export default LocalTable
